var tracking = require('../utils/tracking')
var eventBus = require('../utils/event-bus')
var redirectUrls = require('../utils/redirect-urls')
var cookieKey = require('../constants/cookieKey')

module.exports = Em.Route.extend({
    auth: Em.inject.service(),

    segment: Em.inject.service(),

    model: function() {
        this.controllerFor('user').set('isAuthenticated', false)

        tracking.stopIntercomTracking()
        tracking.stopUserflow()

        var api = this.container.lookup('api:billy')
        var auth = this.get('auth')

        try {
            api.logout().then(function() {
                auth.setScopes([])
            })

            // Unset access token cookie directly before the login.shine.co redirect happens, on root-domain level (cookie is set like this by invoicing app)
            var accessTokenCookieDomain = redirectUrls.getShineAuthCookieDomain()

            if (accessTokenCookieDomain) {
                api.storageAdapter.unsetValue('accessToken', accessTokenCookieDomain)
            }

            api.storageAdapter.unsetValue('accessToken')
            api.storageAdapter.unsetValue(cookieKey.activeSession, accessTokenCookieDomain)

            this.get('segment').track('Signed Out')

            window.analytics.reset()
        } catch(e) {
            // Ignore access token error
        }

        eventBus.trigger('logout')

        var applicationController = this.controllerFor('application')

        if (applicationController && typeof applicationController.resolveWhenOrganizationLoaded === 'function') {
            applicationController.clearGenerateUrlReadyPromise()
        }

        this.replaceWith('login').then(function() {
            BD.store.reset()
        })
    }
})
